package oldcomponents.page

import react.PropsWithChildren
import react.RBuilder
import react.dom.div
import react.dom.h4
import react.fc

external interface WidgetProps : PropsWithChildren {
    var size: String
    var header: String
    var headerOptions: (RBuilder) -> Unit
    var footer: (RBuilder) -> Unit
}

val widget = fc<WidgetProps> { props ->
//    div("row flex-row") {
        div(if (props.size != undefined) props.size else "col-12") {
            div("widget has-shadow") {
                if (props.header != undefined || props.headerOptions != undefined) {
                    div("widget-header bordered no-actions d-flex align-items-center justify-content-${if (props.header != undefined) "between" else "end"}") {
                        if (props.header != undefined && props.header.isNotBlank()) {
                            h4 { +props.header }
                        }
                        if (props.headerOptions != undefined) {
                            div {
                                props.headerOptions(this)
                            }
                        }
                    }
                }
                div("widget-body") {
                    props.children()
                }
                if (props.footer != undefined) {
                    div("widget-footer") {
                        props.footer(this)
                    }
                }
            }
        }
//    }
}